import React, { Fragment, useEffect, useState } from 'react';
import { withRouter } from 'react-router-dom';
import { spinnerOff, spinnerOn } from '../../components/Spinner';
import { post, updateDataTrackerProject } from '../../api';

import IpsDTProjectGrid from '../../components/ProjectsGrid/IpsDTProjectGrid';

import IpsDTProjectList from 'components/ProjectsList/IpsDTProjectList';
import IPSDTViewType from 'components/ViewType/IPSDTViewType';
import ConfirmDialog from 'containers/startproj/DataTrackTabs/CommonComponent/DialogBox/ConfirmDialogBox';
import { directToProject } from '../../utils/Dashboard';

export default withRouter(function DataTrackerNA(props) {
  const { context, history, cardview, onViewTypeChange, projectList } = props;
  const [projects, setProjects] = useState([]);

  const [isLoading, setIsLoading] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [reactivateCurrentProject, setReactivateCurrentProject] = useState({});
  useEffect(() => {
    async function getProjects() {
      if (projects && projects.length < 1) {
        spinnerOn();
        setIsLoading(true);

        const result = await post(`ipsprojects/inactive`, '', {});

        setProjects(result.data);
        spinnerOff();
        setIsLoading(false);
      }
    }

    getProjects();
  }, []);

  async function reactivateProject(project) {
    
    let projectInfo = {
      bpid: project.bpid,
      workOrder: project.workOrder,
      stationName: project.stationName,
    };
    await updateDataTrackerProject(projectInfo);
    setIsModalOpen(false);
    setReactivateCurrentProject({})
    
    // history.push(`/datatracker_progress/${project.stationName}/${project.bpid}/${project.workOrder}/details`);

    // context.setProjectTab('datatracker_progress');
    
directToProject(project,history,'datatracker_progress',context)

  }

  const handleCancel = () => {
    setIsModalOpen(false);
  };
  const handleReactivateProject = (project) => {
    setReactivateCurrentProject(project);
    setIsModalOpen(true);
   
  };
  return (
    <Fragment>
      <div
        style={{
          display: 'flex',
          flexDirection: 'row',
          flewGrow: 1,
          justifyContent: 'center',
          paddingRight: '16px',
          paddingBottom: '16px',
        }}
      >
        <div style={{ flexGrow: 1 }} />
        <IPSDTViewType
          onViewTypeChange={onViewTypeChange}
          tabView={'DT_N'}
          dtstatus={'DT_N'}
        />
      </div>
      {cardview === 'cardview' ? (
        <IpsDTProjectGrid
          projects={projectList(projects)}
          history={history}
          context={context}
          onButtonClick={handleReactivateProject}
          isLoading={isLoading}
          {...props}
        />
      ) : (
        <IpsDTProjectList
          projects={projectList(projects)}
          onButtonClick={handleReactivateProject}
          {...props}
        />
      )}
      {}
      <ConfirmDialog
        show={isModalOpen}
        title={`Do you want to Re-Activate ${reactivateCurrentProject.stationName}?`}
        handleCancel={handleCancel}
        submitFunctionArgs={reactivateCurrentProject}
        handleSubmit={reactivateProject}
        confirmButtonName={'Yes,Re-Activate'}
        cancelButtonName={'No,Cancel'}
      />
    </Fragment>
  );
});
